import { getCidApi, getData, pinCodeInfo } from './api';

/**
 * @description: 获取roomid， channelid
 * @param {object} channel
 * @return {*} {channelid, roomid}
 */
export const getRoomInfo = async (channel: {
    roomid?: number;
    channelid?: number;
    ccid?: number;
}) => {
    if (channel.roomid && channel.channelid) {
        return {
            roomid: channel.roomid,
            channelid: channel.channelid
        };
    } else if (channel.ccid) {
        // 未配置roomid/channelid，则根据ccid获取roomid/channelid
        const data = await getData(getCidApi, {
            anchor_ccid: channel.ccid
        });
        if (data.code === 'OK') {
            return {
                channelid: data.data[channel.ccid].channel_id || 0,
                roomid: data.data[channel.ccid].room_id || 0
            };
        }
    }
    return {
        channelid: 0,
        roomid: 0
    };
};

/**
 * @description: 获取pincode
 * @param {string} act_id
 * @param {number} room_id
 * @param {number} channel_id
 * @return {string}
 */
export const getPinCode = async ({
    act_id,
    room_id,
    channel_id
}: {
    act_id?: string;
    room_id?: number;
    channel_id?: number;
}) => {
    if (!act_id || !room_id || !channel_id) return '';
    const res = await getData(pinCodeInfo, {
        act_id,
        room_id,
        channel_id
    });

    if (res.code === 'OK') {
        return res.data.pincode as string;
    }

    return '';
};
